module.exports = __webpack_public_path__ + "static/img/technology03.e83efe0a.png";